export default __webpack_public_path__ + "static/media/finance_icon.ecbf76a6.svg";